export default "__VITE_PUBLIC_ASSET__dcef68d8__"